export default function Price({ salePrice, originalPrice, displayMode }) {
  if (displayMode === "and") {
    return (
      <>
        {salePrice ? (
          <>
            <span className="book__price--normal">
              ${originalPrice.toFixed(2)}
            </span>
            ${salePrice.toFixed(2)}
          </>
        ) : (
          <>${originalPrice.toFixed(2)}</>
        )}
      </>
    );
  } 
  else if (displayMode === "or") {
    return <>${(salePrice || originalPrice).toFixed(2)}</>;
  } 
  else {
    return (
      <span style={{ color: "red" }}>
        Set displayMode prop to either{" "}
        <span style={{ fontWeight: "bold" }}>'and</span> or{" "}
        <span style={{ fontWeight: "bold" }}>'or'</span>.
      </span>
    );
  }
}
